module.exports = __webpack_public_path__ + "static/9-0f0580a083daa9cf494e7dff21a1b121.png";